import { render, staticRenderFns } from "./LcView.vue?vue&type=template&id=6b674811&"
import script from "./LcView.vue?vue&type=script&lang=js&"
export * from "./LcView.vue?vue&type=script&lang=js&"
import style0 from "./LcView.vue?vue&type=style&index=0&id=6b674811&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports